<template>
  <v-container class="main-container main-container--full-vh">
    <v-row class="tab-select__wrapper">
      <v-col cols="12">
        <v-select :value="tab"
                  :items="optionItems"
                  color="secondary"
                  class="tab-select__input"
                  label="이벤트 분류"
                  outlined hide-details
                  height="80"
                  :menu-props="{
                    offsetY: true,
                    color: 'secondary',
                  }"
                  @change="goToLink({name: 'event', params: {tab: $event}})"
        />
      </v-col>
    </v-row>

    <v-sheet v-for="item in eventList"
             :key="item.brdPostId"
             class="board-information__wrapper"
             role="button"
             @click="goToLink({name: 'event.view', params: {brdPostId: item.brdPostId, hitCnt: item.hitCnt}})"
    >
      <v-chip v-if="optionItems.find(a => a.value === getEventType(item))"
              class="board-information__chip"
              color="primary"
      >
        {{ optionItems.find(a => a.value === getEventType(item)).text }}
      </v-chip>

      <img class="board-information__image"
           :src="imageViewUrl(getThumbnail(item), 686)"
           :alt="item.postTitl"
      >
      <div class="board-information__title">
        {{ item.postTitl }}
      </div>
      <div class="board-information__info">
        <span v-if="getAttrValue(item.attrs, 'replyUse') === 'Y'" class="board-information__reply">
          댓글 {{ item.brdReplyCnt | numberFormat }}
        </span>
        <span v-if="getAttrValue(item.attrs,'hitUse') === 'Y'" class="board-information__view">
          조회 {{ item.hitCnt | numberFormat }}
        </span>
      </div>
    </v-sheet>
  </v-container>
</template>

<script>

import numberFormat from '@/assets/filters/numberFormat';
import imageViewUrl from '@/assets/functions/imageViewUrl';
import { goToLinkMixin } from '@/mixins/goToLinkMixin';
import { eventGetAttrsMixin } from '@/mixins/eventGetAttrsMixin';

export default {
  name: 'EventList',
  filters: {
    numberFormat,
  },
  mixins: [goToLinkMixin, eventGetAttrsMixin],
  props: {
    tab: { type: String, default: null },
  },
  data: () => ({
    optionItems: [
      { text: '전체', value: null },
      { text: '온라인', value: 'ET001' },
      { text: '오프라인', value: 'ET002' },
      { text: '오픈 이벤트', value: 'ET003' },
    ],
    apiUrl: '/v2/board/event/event-post',
    eventList: [],
  }),
  computed: {
    computedParameters () {
      return {
        attrs: this.tab && `eventType.${this.tab}` || '',
        page: 1,
        size: 50,
        filter: '-postCtnt',
      };
    },
    computedTab () {
      this.getList();
      return this.tab;
    },
  },
  watch: {
    tab () {
      this.getList();
    },
  },
  mounted () {
    this.getList();
  },
  methods: {
    imageViewUrl,
    getList () {
      this.$axios.get(this.apiUrl, {
          params: this.computedParameters,
        },
      ).then(response => {
        this.eventList = response.data.data?.content || [];
      });
    },
    getEventType (item) {
      return item.attrs.find(a => a.postAttrNm === 'eventType')?.postAttrVal || null;
    },
    getThumbnail (item) {
      return item.attaches && item.attaches.find(a => a?.brdAtchTpCd === 'BR001')?.brdAtchUri || '';
    },
  },
};

</script>